import React, { createContext, useContext, useEffect, useState } from "react";
import saApi from "../lib/saApi";

// Sticky tenant filter — applied by every mirrored page.
const SATenantCtx = createContext(null);

export function SuperAdminTenantProvider({ children }) {
  const [tenants, setTenants] = useState([]);
  const [tenantId, setTenantId] = useState("all"); // 'all' | tenant.id
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await saApi.get("/tenants");
        setTenants(data.items || []);
      } catch { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, []);

  const currentTenant = tenants.find((t) => t.id === tenantId) || null;

  return (
    <SATenantCtx.Provider value={{ tenants, tenantId, setTenantId, currentTenant, loading }}>
      {children}
    </SATenantCtx.Provider>
  );
}

export const useSuperAdminTenant = () => useContext(SATenantCtx);
